import { ReactNode } from 'react';
import Box from '@mui/material/Box';
import { sp } from '@/theme/mui';

import { Card } from '../Card/Card';
import { Background } from '../Background/Background';

export interface BannerProps {
  className?: string;
  bannerImageUrl: string;
  children?: ReactNode;
  footerContent?: ReactNode;
}

export const BannerImageWithCard = ({
  className,
  bannerImageUrl,
  footerContent,
  children,
}: BannerProps) => (
  <div className={className}>
    <Background src={bannerImageUrl}>
      <Box
        sx={{
          width: '100%',
          maxWidth: '100%',
          m: 0,
          p: 0,
          '@media (min-width: 600px)': { maxWidth: '500px', p: sp[48] },
        }}
      >
        <Card isPaddingSm>{children}</Card>
      </Box>
    </Background>
    {footerContent && (
      <Card isNoPadding isFullWidth color='blue'>
        {footerContent}
      </Card>
    )}
  </div>
);
